<template>
  <div class="context-header row">
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.identificador')}}</b>
      {{document.identificador}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.data')}}</b>
      {{$documentDate(document).join(' ')}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.procedencia')}}</b>
      {{document.procedencia}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.paxinas')}}</b>
      {{document.paxina_inicio}}
      {{
      document.paxina_fin && document.paxina_fin !== document.paxina_inicio ?
      `- ${document.paxina_fin}` : ''
      }}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.outorgante')}}</b>
      {{document.outorgante}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.soporte')}}</b>
      {{document.soporte}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.unidade_arquivistica')}}</b>
      {{document.unidade_arquivistica}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.folios')}}</b>
      {{document.folios_inicio}}
      {{
      document.folios_fin && document.folios_fin !== document.folios_inicio ?
      `- ${document.folios_fin}` : ''
      }}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.tipo_rexistro')}}</b>
      {{document.tipo_rexistro}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.numero_rexistro')}}</b>
      {{document.numero_rexistro}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.volume')}}</b>
      {{document.volume}}
    </div>
    <div class="col-sm-6">
      <b>{{$t('result.context.header.document.numero_documento_edicion')}}</b>
      {{document.numero_documento_edicion}}
    </div>
    <div class="col-sm-12">
      <b>{{$t('result.context.header.document.edicion')}}</b>
      <span v-html="edition"/>
    </div>
  </div>
</template>
<script>
  import {compact} from 'lodash'

  export default {
    props: ['document', 'text'],
    computed: {
      edition() {
        const bcv_title = this.document.bibliografia_revista_titulo_obra_colectiva
        return compact([
          this.document.bibliografia_autor,
          this.document.bibliografia_titulo,
          bcv_title ? `<i>${bcv_title}</i>` : null,
          this.document.bibliografia_revista_volume,
          this.document.bibliografia_revista_numero,
          this.document.bibliografia_lugar_publicacion,
          this.document.bibliografia_editorial,
          this.document.bibliografia_ano,
          this.document.bibliografia_paxinas,
          this.document.bibliografia_numero_tomos,
          this.document.bibliografia_serie,
          this.document.bibliografia_enderezo_web,
          this.document.bibliografia_outras_edicions
        ]).join(', ')
      }
    }
  }
</script>
